import { Pipe, PipeTransform, inject } from '@angular/core';
import { UserLike } from '../services/avatar.service';
import { StateService } from '../services/state.service';

@Pipe({
  name: 'isCurrentUser',
  standalone: true,
})
export class IsCurrentUserPipe implements PipeTransform {
  private state = inject(StateService);
  transform(userLike: UserLike): boolean {
    if (!userLike) return false;
    if (userLike.id === this.state.user?.id) return true;
    if (userLike.id === this.state.guest?.id) return true;
    return false;
  }
}
